import { render, staticRenderFns } from "./CoverImageUploader.vue?vue&type=template&id=19e976b3&scoped=true"
import script from "./CoverImageUploader.vue?vue&type=script&lang=js"
export * from "./CoverImageUploader.vue?vue&type=script&lang=js"
import style0 from "./CoverImageUploader.vue?vue&type=style&index=0&id=19e976b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e976b3",
  null
  
)

export default component.exports